// extracted by mini-css-extract-plugin
module.exports = {"Location":"location-module--Location--2WNj_","Map":"location-module--Map--Mc5P6","Button":"location-module--Button--3niRw"};